import React from "react";
import { Link } from "react-router-dom";
import { MODULE_CONFIG, modulePath } from "../data/modules";

const SOLUTIONS = [
  { key: "cv", label: MODULE_CONFIG.cv.label },
  { key: "skills", label: MODULE_CONFIG.skills.label },
  { key: "pilot", label: MODULE_CONFIG.pilot.label },
  { key: "partners", label: MODULE_CONFIG.partners.label },
  { key: "profile", label: "ASAP Profil" },
].map((s) => ({ ...s, to: modulePath(s.key) }));

const SiteFooter = () => (
  <footer className="mk-site-footer" data-testid="site-footer">
    <div className="mk-wrap mk-footer-grid">
      <div className="mk-footer-brand-col">
        <Link to="/" className="mk-footer-brand" aria-label="ASAP Hub - Accueil">
          <span className="mk-footer-brand-mark" aria-hidden="true" />
          <span className="mk-footer-brand-name">ASAP <em>HUB</em></span>
        </Link>
        <p>La plateforme SaaS &amp; IA qui centralise vos données et booste la performance de votre ESN.</p>
      </div>

      <div className="mk-footer-col">
        <h3>SOLUTIONS</h3>
        {SOLUTIONS.map((s) => (
          <Link key={s.key} to={s.to}>{s.label}</Link>
        ))}
      </div>

      <div className="mk-footer-col">
        <h3>RESSOURCES</h3>
        <Link to="/articles">Guides</Link>
        <a href="/#cas">Cas clients</a>
      </div>

      <div className="mk-footer-col">
        <h3>ENTREPRISE</h3>
        <Link to="/contact">À propos</Link>
        <Link to="/contact">Contact</Link>
        <Link to="/resource/MentionsLegales">Mentions Légales</Link>
        <Link to="/resource/Politique">Politique de confidentialité</Link>
      </div>

      <div className="mk-footer-col mk-footer-contact">
        <h3>NOUS CONTACTER</h3>
        <a href="mailto:hello@asap-cv.fr">✉ hello@asap-cv.fr</a>
        <span>📍 Paris, France</span>
      </div>
    </div>

    <div className="mk-wrap mk-footer-bottom">
      <span>© {new Date().getFullYear()} ASAP Hub · Tous droits réservés</span>
      <span className="mk-footer-badge">🇫🇷 Hébergé en France · RGPD conforme</span>
    </div>
  </footer>
);

export default SiteFooter;
